import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

// Styles
import classes from './AdminCustomer.scss'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { Heading, RadioButtonGroup, Loader } from 'components'

// Helpers
import _get from 'lodash.get'
import _isEqual from 'lodash.isequal'
import { inputProps } from 'helpers/formHelpers'

const mapStateToProps = (state) => ({
  user: _get(state, ['user', 'user']) || {},
  saving: _get(state, ['user', 'saveAttempting']) || false,
  saved: _get(state, ['user', 'saveAttempted']) || false,
  initialValues: {
    referenceId: _get(state, ['user', 'user', 'referenceId']),
    email: _get(state, ['user', 'user', 'email']),
    contactPersonName: _get(state, ['user', 'user', 'contactPersonName']),
    address: _get(state, ['user', 'user', 'address']),
    mobile: _get(state, ['user', 'user', 'mobile']),
    postalCode: _get(state, ['user', 'user', 'postalCode']),
    pharmacyName: _get(state, ['user', 'user', 'pharmacyName']),
    medicalLicenseNo: _get(state, ['user', 'user', 'medicalLicenseNo']),
    facebookName: _get(state, ['user', 'user', 'facebookName']),
    lineId: _get(state, ['user', 'user', 'lineId'])
  }
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  attemptFindOneUser: () =>
    dispatch(userActions.attemptFindOneUser({ userId: ownProps.params.customerId })),
  attemptSaveUser: (payload) =>
    dispatch(userActions.attemptSaveUser(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

const CLASSES = ['ทั่วไป', 'ขายส่งระดับ 1', 'ขายส่งระดับ 2', 'ขายส่งระดับ 3', 'ขายส่งระดับ 4']
const STATUSES = {
  active: 'ผ่าน',
  rejected: 'ไม่ผ่าน',
  pending: 'ยังไม่ระบุ'
}
const FIELD_NAMES = [
  'referenceId', 'email', 'contactPersonName', 'address', 'tel', 'mobile',
  'postalCode', 'pharmacyName', 'medicalLicenseNo', 'facebookName', 'lineId'
]

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'AdminCustomer', fields: FIELD_NAMES })
class AdminCustomer extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    saving: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props)
    this.state = {
      profileInfoEdited: false,
      deliveryInfoEdited: false,
      userClass: _get(props, ['user', 'userClass']) || 0,
      status: _get(props, ['user', 'status']) || 'pending',
      isPharmacy: _get(props, ['user', 'isPharmacy']) || 0
    }
  }

  componentWillMount () {
    this.props.attemptFindOneUser()
  }

  componentWillReceiveProps (nextProps) {
    if (!_isEqual(this.props.user, nextProps.user)) {
      this.setState({
        userClass: _get(nextProps, ['user', 'userClass']) || 0,
        status: _get(nextProps, ['user', 'status']) || 'pending',
        isPharmacy: _get(nextProps, ['user', 'isPharmacy']) || 0
      })
    } else if (this.props.saved !== nextProps.saved) {
      this.setState({ profileInfoEdited: false })
    }
  }

  _onIsPharmacyChange = (isPharmacy) =>
    this.setState({ isPharmacy: parseInt(isPharmacy, 10) });

  _onUserClassChange = (userClass) => {
    this.setState({ userClass: parseInt(userClass, 10) })
  }

  _onStatusChange = (status) => {
    this.setState({ status })
  }

  _onSaveProfileInfo = () => {
    const { attemptSaveUser, user, fields: {
      referenceId, email, contactPersonName, address, mobile,
      postalCode, pharmacyName, medicalLicenseNo,
      facebookName, lineId
    } } = this.props
    attemptSaveUser({
      userId: _get(user, ['userId']),
      referenceId: referenceId.value,
      email: email.value,
      contactPersonName: contactPersonName.value,
      address: address.value,
      mobile: mobile.value,
      postalCode: postalCode.value,
      pharmacyName: pharmacyName.value,
      medicalLicenseNo: medicalLicenseNo.value,
      isPharmacy: this.state.isPharmacy ? 'yes' : 'no',
      facebookName: facebookName.value,
      lineId: lineId.value,
      userClass: this.state.userClass,
      status: this.state.status
    })
    this.setState({ profileInfoEdited: false });
  }

  render () {
    const { user, saving, fields } = this.props
    return (
      <section className={classes.customer}>
        <Heading>แก้ไขข้อมูลลูกค้า</Heading>
        <div className='text-center'>
          <div className={classes.customerInfo}>
            <div className={classes.row}>
              <div className={classes.colLeft}>รหัสลูกค้า</div>
              <div className={classes.colRight}>
                <span>{_get(user, ['userId'])}</span>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>รหัสใน CW</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.referenceId)} />
                  : <span>{_get(user, ['referenceId']) || '-'}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>Email</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.email)} />
                  : <span>{_get(user, ['email'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>Name</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.contactPersonName)} />
                  : <span>{_get(user, ['contactPersonName'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ที่อยู่จัดส่ง</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.address)} />
                  : <span>{_get(user, ['address'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>เบอร์โทรติดต่อ</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.mobile)} />
                  : <span>{_get(user, ['mobile'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>รหัสไปรษณีย์</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.postalCode)} />
                  : <span>{_get(user, ['postalCode'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อร้าน/บริษัท</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.pharmacyName)} />
                  : <span>{_get(user, ['pharmacyName'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>เลขที่ใบอนุญาต</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.medicalLicenseNo)} />
                  : <span>{_get(user, ['medicalLicenseNo'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>เป็นคลินิก/ร้านขายยา</div>
              <div className={classes.colRight}>
                <RadioButtonGroup name='userClass'
                  disabled={!this.state.profileInfoEdited}
                  radioClassName={classes.radio}
                  selectedValue={this.state.isPharmacy}
                  onChange={this._onIsPharmacyChange}
                  options={[
                    { title: 'ใช่', value: 1 },
                    { title: 'ไม่ใช่', value: 0 }
                  ]} />
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อใน Facebook</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.facebookName)} />
                  : <span>{_get(user, ['facebookName'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อใน Line</div>
              <div className={classes.colRight}>
                {this.state.profileInfoEdited
                  ? <input type='text' {...inputProps(fields.lineId)} />
                  : <span>{_get(user, ['lineId'])}</span>}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>Class</div>
              <div className={classes.colRight}>
                <RadioButtonGroup name='userClass'
                  disabled={!this.state.profileInfoEdited}
                  radioClassName={classes.radio}
                  selectedValue={this.state.userClass}
                  onChange={this._onUserClassChange}
                  options={CLASSES.map((title, index) => ({ title, value: index }))} />
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ยืนยันสมาชิก</div>
              <div className={classes.colRight}>
                <RadioButtonGroup name='status'
                  disabled={!this.state.profileInfoEdited}
                  radioClassName={classes.radio}
                  selectedValue={this.state.status}
                  onChange={this._onStatusChange}
                  options={Object.keys(STATUSES).map(key => ({
                    title: STATUSES[key], value: key
                  }))} />
              </div>
            </div>
          </div>
          {!this.state.profileInfoEdited ? (
            <div>
              <div className={classes.button}
                onClick={() => this.setState({ profileInfoEdited: !this.state.profileInfoEdited })}>
                <span>แก้ไข</span>
              </div>
            </div>
          ) : (
            <div>
              <div className={`${classes.button} ${classes.orange}`}
                onClick={() => this.setState({ profileInfoEdited: !this.state.profileInfoEdited })}>
                <span>ยกเลิก</span>
              </div>
              <div className={classes.button} onClick={this._onSaveProfileInfo}>
                {saving ? <Loader /> : <span>บันทึก</span>}
              </div>
            </div>
          )}
        </div>
        <Heading>ข้อมูลส่วนตัว</Heading>
        <div className='text-center'>
          <div className={classes.otherInfo}>
            <div className={classes.row}>
              <div className={classes.colLeft}>Username</div>
              <div className={classes.colRight}>{_get(user, ['email'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อผู้ติดต่อหลัก</div>
              <div className={classes.colRight}>{_get(user, ['contactPersonName'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ที่อยู่จัดส่ง</div>
              <div className={classes.colRight}>{_get(user, ['address'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>รหัสไปรษณีย์</div>
              <div className={classes.colRight}>{_get(user, ['postalCode'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อร้าน/บริษัท</div>
              <div className={classes.colRight}>{_get(user, ['pharmacyName'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>เลขที่ใบอนุญาตขายยาหรือประกอบโรคศิลป์</div>
              <div className={classes.colRight}>{_get(user, ['medicalLicenseNo'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ใบอนุญาตขายยา</div>
              <div className={classes.colRight}>
                <a href={_get(user, ['pharmacyLicensePath'])}>
                  <img src={_get(user, ['pharmacyLicensePath'])} alt='pharmacyLicensePath' />
                </a>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ใบประกอบวิชาชีพ</div>
              <div className={classes.colRight}>
                <a href={_get(user, ['professionalLicensePath'])}>
                  <img src={_get(user, ['professionalLicensePath'])} alt='professionalLicensePath' />
                </a>
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อใน Facebook</div>
              <div className={classes.colRight}>{_get(user, ['facebookName'])}</div>
            </div>
            <div className={classes.row}>
              <div className={classes.colLeft}>ชื่อใน Line</div>
              <div className={classes.colRight}>{_get(user, ['lineId'])}</div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default AdminCustomer



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/AdminCustomer/AdminCustomer.js
 **/